import { useTranslation } from "react-i18next";

import { PlusOutlined } from "@ant-design/icons";
import { Select as AntSelect, Col, Divider, Form, Modal, Row, Space, Button, Flex } from "antd";
import { CardContainer } from "components/elements";
import { Select } from "components/form";
import { useSelector } from "react-redux";
import { Option } from "antd/es/mentions/index.js";
import EmployeeWorkInWorkInLocationTable from "components/table/EmployeeWorkInWorkInLocationTable";
import { Formik } from "formik";
import employeeWorkInLocationSchema from "../schemas/employeeWorkInLocationSchema.js";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";

function EmployeeWorkInWorkInLocation({
  pagination = {},
  isLoading = false,
  isModalOpen = false,
  workInLocationId = "",
  workInLocationList = [],
  workInLocationOptions = [],
  deviceTypeOptions = [],
  currentDeviceType = "",
  onDeviceTypeChange = () => { },
  onChange = () => { },
  onCancel = () => { },
  onSubmit = () => { },
  onCreate = () => { },
  onDelete = () => { },
}) {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  console.log(workInLocationOptions, workInLocationOptions.length);

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Modal
        title={t("common.create")}
        open={isModalOpen}
        onOk={() => { }}
        onCancel={() => {
          const cancelBtn = document.getElementById("work_in_location_cancelBtn");
          if (cancelBtn) {
            cancelBtn.click();
          } else {
            onCancel();
          }
        }}
        width="450px"
        footer={null}
        closable={false}
        maskClosable={false}
      >
        <Formik
          enableReinitialize
          initialValues={{ workInLocationId }}
          onSubmit={onSubmit}
          validationSchema={employeeWorkInLocationSchema}
        >
          {({ values = {}, submitForm, setFieldValue, resetForm }) => {
            return (
              <Form onFinish={submitForm}>
                <Space direction="vertical" size={2} style={{ width: "100%" }}>
                  <Row gutter={[24, 10]}>
                    <Col span={24}>
                      <Select
                        required
                        name="workInLocationId"
                        label={t("tab.menu.label.work-in-location")}
                        placeholder={t("common.pleaseSelect")}
                        size="large"
                        options={workInLocationOptions}
                        value={{}}
                      />
                    </Col>
                  </Row>
                  <div style={{ height: 12 }} />
                  <Row justify="end">
                    <Space direction="horizontal" size={12}>
                      <Button
                        id="work_in_location_cancelBtn"
                        type="default"
                        onClick={() => {
                          resetForm();
                          onCancel();
                        }}
                        style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content" }}
                      >
                        {t("common.cancel").toUpperCase()}
                      </Button>
                      <Button htmlType="submit" type="primary"
                        style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content", backgroundColor: "var(--button-color)" }}
                      >
                        {t("common.submit").toUpperCase()}
                      </Button>
                    </Space>
                  </Row>
                </Space>
              </Form>
            );
          }}
        </Formik>
      </Modal>
      <Row justify="end">
        <Space direction="horizontal" size={12}>
          <AntSelect
            value={currentDeviceType}
            defaultValue={currentDeviceType}
            onChange={onDeviceTypeChange}
            style={{ height: "40px" }}
          >
            {deviceTypeOptions.map(option => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </AntSelect>
          {
            roles.includes("CREATE_EMPLOYEE|WORK_IN|WORK_IN_LOCATION") && <Button onClick={onCreate} disabled={workInLocationOptions.length === 0 ? true : false}
              type="primary"
              style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}
            >
              <Flex align="center" justify="center" gap={8}>
                <CreateIcon />
                {t("common.create")}
              </Flex>
            </Button>
          }

        </Space>
      </Row>
      <EmployeeWorkInWorkInLocationTable
        isLoading={isLoading}
        dataSource={workInLocationList}
        pagination={pagination}
        onChange={onChange}
        onDelete={onDelete}
      />
    </Space>
  );
}

export default EmployeeWorkInWorkInLocation;
